import React, { Component } from 'react';
import { observable, action } from 'mobx';
import { observer, inject } from 'mobx-react';
import { Spring, interpolate } from 'react-spring';

import Constraint from 'js/components/Constraint';
import Content from './Content';
import TitleEditor from './TitleEditor';
import PriceEditor from './PriceEditor';
import ItemImage from './ItemImage';

@inject('page')
@observer
export default class ItemInformation extends Component {
  @observable hasMovedDropzone = this.props.page.title.length > 0;
  @observable hasMovedTitleEdit = false;
  @action setHasMovedDropzone = () => (this.hasMovedDropzone = this.props.page.hasEnteredTitle);
  @action setHasMovedTitleEdit = () => (this.hasMovedTitleEdit = this.props.page.hasEnteredPrice);

  render() {
    const page = this.props.page;
    return (
      <Constraint>
        <Spring
          native
          from={{
            margin: !page.hasEnteredTitle ? '50%' : '0%',
            offset: !page.hasEnteredTitle ? '30px' : '0px',
          }}
          to={{
            margin: !page.hasEnteredTitle ? '50%' : '0%',
            offset: !page.hasEnteredTitle ? '30px' : '0px',
          }}
          config={{ tension: 200, clamp: true }}
          onRest={this.setHasMovedDropzone}>
          {({ margin, offset }) => (
            <ItemImage
              style={{
                marginLeft: interpolate([margin, offset], (margin, offset) => `calc(${margin} - ${offset})`),
              }}
            />
          )}
        </Spring>

        {this.hasMovedDropzone && (
          <>
            <Spring
              native
              from={{
                marginTop: !page.hasEnteredPrice ? '20px' : '0px',
                top: !page.hasEnteredPrice ? '-0.5rem' : '0rem',
                opacity: 0,
              }}
              to={{
                marginTop: !page.hasEnteredPrice ? '20px' : '0px',
                top: !page.hasEnteredPrice ? '-0.5rem' : '0rem',
                opacity: 1,
              }}
              config={{ tension: 170, friction: 20, velocity: 1, clamp: true }}
              onRest={this.setHasMovedTitleEdit}>
              {animation => (
                <Content style={animation}>
                  <TitleEditor />
                </Content>
              )}
            </Spring>

            {this.hasMovedTitleEdit && (
              <Spring
                native
                from={{
                  opacity: 0,
                }}
                to={{
                  opacity: 1,
                }}
                config={{ tension: 170, friction: 20, velocity: 1, clamp: true }}>
                {animation => (
                  <Content style={animation}>
                    <PriceEditor />
                  </Content>
                )}
              </Spring>
            )}
          </>
        )}
      </Constraint>
    );
  }
}
